import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback } from '@redneckz/uni-jsx/lib/hooks';
import { useLink } from '../../hooks/useLink.js';
import { TabItemInner } from './TabItemInner.js';
export const TabItem = JSX((props) => props?.item?.href ? _jsx(LinkTabItem, { ...props }) : _jsx(ButtonTabItem, { ...props }));
const LinkTabItem = JSX((props) => {
    const link = useLink();
    const handleClick = useCallback(() => {
        props.onClick && props.onClick(props.item || {});
    }, [props.onClick, props.item]);
    const { onClick, ...item } = link({ ...props.item, onClick: handleClick });
    return _jsx(TabItemInner, { ...props, tag: "a", item: item, onClick: onClick });
});
// TODO: Update handlerDecorator (support buttons?)
const ButtonTabItem = JSX(({ item = {}, onClick, ...rest }) => {
    const handleClick = useCallback(() => {
        onClick && onClick(item);
    }, [onClick, item]);
    return _jsx(TabItemInner, { item: item, onClick: handleClick, ...rest });
});
//# sourceMappingURL=TabItem.js.map